<!-- Command Central Common Header -->
@if (currentPage !== 'self-registration-setup') {
	<cc-common-header [search]="false">
		<cc-header-left-plugin-area
			class="msi-common-header-left-plugin-area"
			applicationName="Orchestrate"
			applicationHomeUrl="workflows">
		</cc-header-left-plugin-area>

		<cc-header-right-plugin-area class="msi-common-header-right-plugin-area">
			<div>
				<cc-application-switcher class="msi-common-header-plugin"> </cc-application-switcher>
			</div>
			<div class="msi-common-header-plugin">
				<app-support-info> </app-support-info>
			</div>
			<cc-session-manager class="msi-session-manager"> </cc-session-manager>
		</cc-header-right-plugin-area>
	</cc-common-header>
}

<!-- Inject a div with adblock detectable classes to let the Ad blocker disable the div -->
<div #adBanner class="adblockDetect adBanner adbanner ad_banner" id="adbanner"></div>

<!-- MSI Sidebar -->
@if (showCurrentPageInSidebar) {
	<msi-sidebar role="navigation" [expanded]="sidebarExpanded" (isExpanded)="toggleSidebarExpansion($event)">
		<msi-sidebar-top>
			<!-- 'Create New' flyout buttons-->
			<div class="create-new">
				<msi-sidebar-item
					id="createNewBtn"
					icon="ic_add"
					[isFlyout]="true"
					[msiDropdownTriggerFor]="createNewFlyout"
					i18n-description
					description="Create New">
				</msi-sidebar-item>
			</div>
			<!-- Flyout dropdown list -->
			<msi-dropdown #createNewFlyout width="196" xPosition="right" yPosition="below">
				@if (!atLeastOneWorkspace || !canUserEditWorkflow) {
					<div
						msiTooltip
						[templateRef]="newWorkflowDisabledTooltip"
						position="right"
						[showDelay]="250"
						[hideDelay]="500">
						<msi-dropdown-item [disabled]="true" id="createWorkflowBtnDisabled">
							<msi-icon name="ic_workflow" class="disable-msi-icon"></msi-icon>
							<span i18n>Workflow</span>
						</msi-dropdown-item>
						<ng-template #newWorkflowDisabledTooltip>
							<div class="dropdown-tooltip-contents">
								@if (!atLeastOneWorkspace) {
									<div i18n>You need to have a Workspace created before you can create a Workflow.</div>
								}
								@if (!canUserEditWorkflow) {
									<div i18n>You do not have permissions to create/edit Workflows.</div>
								}
							</div>
						</ng-template>
					</div>
				} @else {
					<msi-dropdown-item id="createWorkflowBtnEnabled" (press)="navigateTo('new-workflow')">
						<msi-icon name="ic_workflow"></msi-icon>
						<span i18n>Workflow</span>
					</msi-dropdown-item>
				}
				@if (!canCreateNewWorkspaces) {
					<div
						msiTooltip
						[templateRef]="newWorkspaceDisabledTooltip"
						position="right"
						[showDelay]="250"
						[hideDelay]="500">
						<msi-dropdown-item [disabled]="true" id="createWorkspaceBtnDisabled">
							<msi-icon name="ic_folder" class="disable-msi-icon"></msi-icon>
							<span i18n>Workspace</span>
						</msi-dropdown-item>
						<ng-template #newWorkspaceDisabledTooltip>
							<div class="dropdown-tooltip-contents" i18n>You do not have permissions to create/edit Workspace.</div>
						</ng-template>
					</div>
				} @else {
					<msi-dropdown-item (press)="navigateTo('new-workspace')" id="createWorkspaceBtn">
						<msi-icon name="ic_folder"></msi-icon>
						<span i18n>Workspace</span>
					</msi-dropdown-item>
				}

				<msi-dropdown-item (press)="navigateTo('connections')" id="createConnectionsBtn">
					<msi-icon name="ic_connections"></msi-icon> <span i18n>Connection</span>
				</msi-dropdown-item>
			</msi-dropdown>
			<msi-sidebar-item
				id="workflows-icon"
				icon="ic_workflow"
				i18n-description
				description="Workflows"
				routerLink="/workflows"
				[class.selected]="currentPage === 'workflows' || currentPage === ''">
			</msi-sidebar-item>
			<msi-sidebar-item
				id="monitor-icon"
				icon="ic_system_status"
				i18n-description
				description="Monitor"
				routerLink="/monitor/runtime-data"
				[class.selected]="currentPage === 'monitor'">
			</msi-sidebar-item>
			<msi-sidebar-item
				id="connection-center-icon"
				icon="ic_connections"
				i18n-description
				description="Connection Center"
				routerLink="/connections"
				[class.selected]="currentPage === 'connections' || currentPage === 'product-details'">
			</msi-sidebar-item>
		</msi-sidebar-top>
		<msi-sidebar-bottom>
			<msi-sidebar-item
				id="settings-icon"
				icon="ic_settings"
				i18n-description
				description="Settings"
				routerLink="/settings"
				[class.selected]="currentPage === 'settings'">
			</msi-sidebar-item>
		</msi-sidebar-bottom>
	</msi-sidebar>
}

<!-- Page contents depends on route -->
<router-outlet></router-outlet>

<!-- Open the modal on any page if the existing user hasn't accepted agreements -->
@if (showCurrentPageInSidebar) {
	<app-agreements-modal-invoker></app-agreements-modal-invoker>
}

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
